@if (bloc.isInvoice$ | async) {
  <div *ngIf="practitionerClaims$ | async as practitionerClaims">
    <h2>Healthcare Claims</h2>
    <pr-healthcare-claims-list
      *ngIf="practitionerClaims.length; else noClaims"
      [invoice]="invoice$ | async"
      [practitionerClaims]="practitionerClaims"
    />
    <ng-template #noClaims>
      <p class="mat-caption">
        No healthcare claims are available for this invoice.
      </p>
    </ng-template>
  </div>
}

<div>
  <h2>Transactions</h2>

  @if (bloc.canAddTransactions$ | async) {
    <div class="flex flex-col gap-2">
      <pr-deposit-payment-notice
        [appointment]="appointment()"
        [creditAvailable]="accountCreditAvailable()"
        [applyingCredit]="applyingCredit()"
        [bookingDepositTotal]="matchingCreditTotal()"
        [availableCreditTotal]="availableCreditTotal()"
        [creditStateQueryFailed]="creditStateQueryFailed()"
        (applyCredit)="useCredit()"
      />
      @if (paymentActionsReady()) {
        <pr-add-transaction [invoice]="invoice$ | async" />
      } @else {
        <pr-information-box>
          <div class="flex flex-row items-center gap-2">
            <div class="flex-1">{{ autoApplyProgressLabel() }}</div>
            <mat-spinner diameter="24" />
          </div>
        </pr-information-box>
      }
    </div>
  }

  @if (transactions$ | async; as transactions) {
    @if (transactions.length) {
      <div class="transactions">
        <pr-transactions-display
          [invoice]="invoice$ | async"
          [transactions]="transactions"
        />
      </div>
    }
  }
</div>
